const Spacer = ({ size }) => {
  return <div style={{ height: size || '1em', width: '100%' }} />;
};

export default Spacer;
